import { render, staticRenderFns } from "./international_Communication_Capacity_Building.vue?vue&type=template&id=65c15f98&scoped=true"
import script from "./international_Communication_Capacity_Building.vue?vue&type=script&lang=js"
export * from "./international_Communication_Capacity_Building.vue?vue&type=script&lang=js"
import style0 from "./international_Communication_Capacity_Building.vue?vue&type=style&index=0&id=65c15f98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c15f98",
  null
  
)

export default component.exports